var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-24", attrs: { id: "prompting-classic" } },
    [
      _c("div", { staticClass: "flex justify-center py-10" }, [
        _c(
          "div",
          {
            staticClass:
              "relative py-5 border w-180 h-min bg-pure-white border-slate-400 rounded-3xl",
            attrs: { id: "prompting-card" }
          },
          [
            _c(
              "div",
              {
                staticClass: "px-10 py-5 space-y-4 border-b border-slate-400",
                attrs: { id: "prompting-header" }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-1" },
                  [
                    _c("BlTextSubtitle1", {
                      staticClass: "text-slate-700",
                      attrs: { text: "Custom:" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlTextTitle3", {
                          attrs: { text: "Score-Based Prompting" }
                        }),
                        _vm._v(" "),
                        _c("BlBubbleCount", {
                          attrs: { count: _vm.centerPrompts.length || 0 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "These prompts are used in Prompting. Changing or deleting them here will not affect the existing prompts already used by the client."
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            !_vm.currentUser.role.includes("admin")
              ? _c("div", { staticClass: "w-full px-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-2 px-4 py-2 rounded-b bg-info-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "grid flex-shrink-0 w-10 h-10 place-items-center",
                          style: {
                            background: "#E4F1FA",
                            borderRadius: "0.25rem"
                          }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "toast-info" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextBody1", {
                        staticClass: "text-info",
                        attrs: {
                          text:
                            "Please note that the ability to add or edit in the Repository is restricted to users with the Admin role."
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pageLoading
              ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                  _c("div", { staticClass: "blum-loader" })
                ])
              : _c(
                  "div",
                  {
                    staticClass: "flex flex-col items-center",
                    attrs: { id: "prompting-body" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-col w-full gap-6 py-6",
                        style: { maxWidth: "80rem" }
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "px-10" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center py-4 border rounded-lg bg-slate-100 border-grey-200"
                              },
                              [
                                _c("PromptPreview", {
                                  style: { transform: "scale(0.75 , 0.75)" },
                                  attrs: { prompts: _vm.sortedPrompts }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "px-10" }, [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-4 mb-2" },
                            [
                              _c("BlTextSubtitle4", {
                                staticClass: "flex-shrink-0 w-15",
                                attrs: { text: "Score (%)" }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle4", {
                                staticClass: "flex-shrink-0 w-15",
                                attrs: { text: "Code" }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle4", {
                                staticClass: "flex-shrink-0 w-24",
                                attrs: { text: "Symbol" }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle4", {
                                staticClass: "w-full",
                                attrs: { text: "Prompt name" }
                              }),
                              _vm._v(" "),
                              _vm.currentUser.role.includes("admin")
                                ? _c("div", {
                                    staticClass: "flex-shrink-0 w-6"
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "flex flex-col gap-4": _vm.currentUser.role.includes(
                                  "admin"
                                )
                              }
                            },
                            _vm._l(_vm.sortedPrompts, function(prompt) {
                              return _c("PromptItem", {
                                key: prompt.id,
                                attrs: {
                                  prompt: prompt,
                                  format: "custom",
                                  readOnly: !_vm.currentUser.role.includes(
                                    "admin"
                                  )
                                },
                                on: {
                                  update: _vm.onUpdate,
                                  delete: _vm.onRemove
                                }
                              })
                            }),
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.currentUser.role.includes("admin")
                          ? _c(
                              "div",
                              { staticClass: "px-10 mt-2" },
                              [
                                _c("BlInputButton", {
                                  staticClass: "px-0",
                                  attrs: {
                                    icon: "plus",
                                    label: "Add prompt",
                                    type: "plain"
                                  },
                                  on: { clicked: _vm.onCreate }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b86b987", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b86b987","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/prompting/Custom.vue
// module id = null
// module chunks = 